import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Card, Col, Container, Row } from "react-bootstrap";
import bgImage from "../assets/images/login-slider-bg-image.png";
import LoginSliderDotIcon from "../assets/svgIcons/LoginSliderDotIcon";
import AuthSliderOvalIcon from "../assets/svgIcons/AuthSliderOvalIcon";
import { media } from "../utils/helper";
import StyledText from "./StyledComponents/StyledText";
import sliderOneImage from "../assets/images/auth-slider-01.png";
import sliderTwoImage from "../assets/images/auth-slider-02.png";
import AppLogoWhite from "../assets/svgIcons/AppLogoWhite";
import { theme } from "../theme";
import ScryptxLogo from "../assets/svgIcons/ScryptxLogo";

const AuthSlider = ({ children }) => {
  const images = [
    {
      image: sliderOneImage,
      text: "One place to manage your profile and add multiple identities",
    },
    {
      image: sliderTwoImage,
      text: "Add or delete multiple identities and login with any identity",
    },
  ];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSlide, setIsSlide] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images?.length - 1 ? 0 : prevIndex + 1,
      );
      setIsSlide((prevIsSlide) => !prevIsSlide);
    }, 8000);

    return () => {
      clearInterval(interval);
    };
  }, [images?.length]);

  const changeImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images?.length - 1 ? 0 : prevIndex + 1,
    );
    setIsSlide((prevIsSlide) => !prevIsSlide);
  };

  return (
    <StyledBackground className="p-0">
      <StyledSection fluid className="h-100">
        <Row className="justify-content-between h-100">
          <Col
            md={6}
            className="d-flex flex-column align-items-center justify-content-center left-container py-md-0"
          >
            <div className="mt-4 mt-md-0 pb-md-5 d-block d-md-none pb-4 pb-md-0">
              <AppLogoWhite />
            </div>
            <AnimateSlide className="fadeIn">
              <img alt="sliderImage" src={images[currentIndex]?.image} />
            </AnimateSlide>
            <StyledText
              as="h5"
              color="white"
              $fontSize="1.2rem"
              $fontWeight="600"
              $fontSizeMd="15px"
            >
              {images[currentIndex]?.text}
            </StyledText>
            <div
              className={`d-flex justify-content-center gap-2 mb-2 mb-md-0 ${
                !isSlide ? "flex-row" : "flex-row-reverse"
              }  mt-3 mt-md-4 cursor-pointer`}
            >
              <LoginSliderDotIcon onClick={changeImage} />
              <AuthSliderOvalIcon onClick={changeImage} />
            </div>
          </Col>
          <Col md={6} className="py-0 py-md-5 bg-white">
            <StyledLoginForm className="p-md-2 p-xxl-3 border-0 rounded-0 h-100">
              <Card.Body className="p-xl-2 p-xxl-5 d-flex flex-column justify-content-start justify-content-md-center __card-body">
                <div className="pb-2 pb-md-5 d-none d-md-block">
                  <ScryptxLogo symbolColor={theme.colors.primaryLight} color={theme.colors.secondary} size={264} />
                </div>
                {children}
              </Card.Body>
            </StyledLoginForm>
          </Col>
        </Row>
      </StyledSection>
    </StyledBackground>
  );
};

const StyledBackground = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSection = styled(Container)`
  background-color: ${({ theme }) => theme.colors.white};

  .left-container {
    background: url(${bgImage}) center center no-repeat;
    background-size: cover;

    h5 {
      text-align: center;
      margin-top: 10px;
      width: 50%;
      ${media.xl`
       width : 80%;`}
    }
  }
`;

const AnimateSlide = styled.div`
  animation: ${({ isSlide }) => (isSlide ? "fadeOut" : "fadeIn")} 2s forwards;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  ${media.lg`
       max-width: 65%;
         img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            }
        `}
`;

const StyledLoginForm = styled(Card)`
  .__card-body {
    max-width: 80%;
    align-self: center;
    width: 100%;

    ${media.xl`
        max-width: 100%;
  `}
    .sign-in-btn {
      ${media.md`
       padding: 12px;
       margin-top: 15px;
  `}
    }
  }

  .welcome-heading {
    color: ${({ theme }) => theme.colors.secondary};
    font-size: 22px;
    font-weight: 600;
    ${media.md`
        font-size: 20px;
        margin-top: 20px;
  `}
  }

  .signin-text {
    color: ${({ theme }) => theme.colors.regularText};
    font-size: 14px;
    ${media.md`
        font-size: 13px;
        font-weight: 400;
        margin-bottom: 20px;
  `}
  }
`;

export default AuthSlider;
